import React, {Component, PropTypes} from 'react';
import {connectReduxForm} from 'redux-form';
import {validateRegistration} from 'utils/validateNormalize';
import Spinner from "react-spinner"
import {
  GetFirstName,
  GetLastName,
  GetPhone,
  GetPasword,
  GetEmail,
  GetTermsAccepted,
  GetOptIn
} from "./registrationComponents";

@connectReduxForm({
  form: 'register',
  fields: [
    'alert',
    'email',
    'password',
    'firstName',
    'lastName',
    'phone',
    'termsAccepted',
    'directPromotionOptIn',
    'marketingOptIn'
  ],
  validate: validateRegistration
})
export default class RegisterForm extends Component {
  static propTypes = {
    fields: PropTypes.shape({
      alert: PropTypes.object.isRequired,
      email: PropTypes.object.isRequired,
      password: PropTypes.object.isRequired,
      firstName: PropTypes.object.isRequired,
      lastName: PropTypes.object.isRequired,
      phone: PropTypes.object.isRequired,
      termsAccepted: PropTypes.object.isRequired,
      directPromotionOptIn: PropTypes.object.isRequired,
      marketingOptIn: PropTypes.object.isRequired
    }).isRequired,
    submitting: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      showTermsAndConditionsModal: false,
      showDataUsageModal: false
    };
  }

  closeDataUsage() {
    this.setState({
      ...this.state,
      showDataUsageModal: false
    })
  }

  openTerms() {
    this.setState({
      ...this.state,
      showTermsAndConditionsModal: true
    })
  }

  closeTerms() {
    this.setState({
      ...this.state,
      showTermsAndConditionsModal: false
    })
  }

  openDataUsage() {
    this.setState({
      ...this.state,
      showDataUsageModal: true
    })
  }

  render() {
    const {
      fields: {
        alert,
        email,
        password,
        firstName,
        lastName,
        phone,
        termsAccepted,
        directPromotionOptIn,
        marketingOptIn
      },
      invalid
    } = this.props;

    return (
      <div className="col-lg-8 col-md-8 col-sm-6">
        <div>
          <h2>Register to get access</h2>
          {alert.error &&
            <div className="form-group">
              <div className="alert alert-danger" dangerouslySetInnerHTML={{__html: alert.error}}></div>
            </div>
          }
          <label className="control-label" style={{float: "right"}}>* Required Fields</label>
          <h3>Personal</h3>
          <hr/>
          <GetFirstName firstName={firstName}/>
          <GetLastName lastName={lastName}/>
          <GetPhone phone={phone}/>
          <h3>Account</h3>
          <hr/>
          <GetEmail email={ email }/>
          <GetPasword password={ password }/>
          <h3>Communications</h3>
          <hr/>
          <GetOptIn label="Information about free programs in my area (2-4 messages per year)" optIn={ directPromotionOptIn }/>
          <GetOptIn label="Newsletter with exclusive content and product news (4-6 messages per year)" optIn={ marketingOptIn }/>
          <br/>
          <GetTermsAccepted
            termsAccepted={ termsAccepted }
            showTermsAndConditionsModal={ this.state.showTermsAndConditionsModal }
            showDataUsageModal={ this.state.showDataUsageModal }
            openTerms={ () => this.openTerms.bind(this) }
            closeTerms={ () => this.closeTerms.bind(this) }
            openDataUsage={ () => this.openDataUsage.bind(this) }
            closeDataUsage={ () => this.closeDataUsage.bind(this) }
          />
          <button
            onClick={::this.props.handleSubmit}
            disabled={invalid}
            className={this.props.submitting ? "btn btn-lg btn-primary spinnerButton disabled" : 'btn btn-lg btn-primary spinnerButton' }
          >
            <div className='buttonText'>
              {
                this.props.submitting
                  ? 'Registering'
                  : 'Register'
              }
            </div>
            {this.props.submitting ?
              <div className="spinnerWrapper">
                <Spinner />
              </div> : <div></div>
            }
          </button>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/auth/registerForm.jsx